import styles from './mainView.module.css';

type IFloorAlertBadgeProps = {
  count: number;
  /** `critical` → red glyph; `high` → orange. Mirrors trusstor's severity rule
   *  (`SafetyIcon` switches between `safetyOrange` and `safetyRed` SVGs). */
  severity: 'critical' | 'high';
  onClick: () => void;
  ariaLabel: string;
};

/**
 * Per-floor safety badge that hangs in the side rail next to the building.
 * Mirrors trusstor's `SafetyIcon.tsx`:
 *   - 16×16 circle (orange `#f46e0a` or red `#d81a1a`) with a white "!" inside.
 *   - 12×12 white avatar pinned top-right with the active-event count in
 *     dark text.
 */
export function FloorAlertBadge({ count, severity, onClick, ariaLabel }: IFloorAlertBadgeProps) {
  return (
    <button
      type="button"
      className={styles.alertBadge}
      data-severity={severity}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {/* The base disc uses `currentColor`; the badge's wrapping CSS
          rule sets `color: var(--safety-alert-orange | red)` based on
          `data-severity`, which keeps all hex values inside tokens.css. */}
      <svg
        viewBox="0 0 60.4 60.4"
        width="16"
        height="16"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="30.2" cy="30.2" r="30.2" fill="currentColor" />
        {/* Exclamation bar + dot (lifted from trusstor's
            dash-icon-orange-alert.svg / dash-icon-red-alert.svg). */}
        <path
          d="M26.18 15.1a4 4 0 0 1 4-4 4 4 0 0 1 4 4v16.17a4 4 0 0 1-4 4 4 4 0 0 1-4-4z"
          fill="white"
        />
        <circle cx="30.2" cy="44.48" r="4.92" fill="white" />
      </svg>
      {count > 0 && (
        <span className={styles.alertBadgeCount}>{count}</span>
      )}
    </button>
  );
}
